<template>
  <div>
    <div class="d-flex justify-content-between align-items-center pt-50 mb-2">
      <h2 class="font-weight-bolder m-0">
        <span @click="$router.go(-1)">
          <b-button
              variant="white"
              class="btn-icon rounded-circle mr-50 text-primary bg-white"
              size="sm"
          >
            <feather-icon icon="ChevronLeftIcon" />
          </b-button>
        </span> Detalles categoria
      </h2>
    </div>
    <b-card>
      <validation-observer ref="editCategory">
        <b-form
            class="mt-2"
            @submit.prevent="handleSubmit"
            @keydown.enter="handleSubmit"
        >
          <b-row>
            <b-col :cols="12">
              <b-form-group :label="'Activo'" label-for="category-active" >
                <b-form-checkbox
                    v-model="category.active"
                    switch
                    :value="1"
                    :unchecked-value="0"
                />
              </b-form-group>
            </b-col>
            <b-col :cosl="12">
              <validation-provider
                  #default="{ errors }"
                  name="Nombre"
                  rules="required"
              >
                <b-form-group
                    label="Nombre"
                    label-for="category-name"
                >
                  <b-form-input
                      v-model="category.name"
                      name="name"
                      placeholder="Nombre"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12">
              <b-form-group
                  :label="'Descripción'"
                  label-for="category-description"
              >
                <quill-editor
                    v-model="category.description"
                    :options="editorOption"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12 text-right">
              <b-button
                  type="submit"
                  variant="primary"
                  class="mt-2 mr-1"
              >
                Enviar
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BFormCheckbox
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import Ripple from 'vue-ripple-directive'
import { quillEditor } from 'vue-quill-editor'
import quillMixin from '@/mixins/quillMixin'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    ValidationProvider,
    ValidationObserver,
    quillEditor,
    BFormCheckbox
  },
  directives: {
    Ripple,
  },
  mixins: [quillMixin],
  data() {
    return {
      required,
      email,
    }
  },
  computed: {
    ...mapGetters({
      category: 'documents/getCategory',
      currentClient: 'clients/getCurrentClient',
      role: 'auth/getRole',
    }),
  },
  methods: {
    ...mapActions({
      edit: 'documents/editCategory',
      getCategory: 'documents/getCategory',
    }),
    handleSubmit() {
      this.$refs.editCategory.validate().then(success => {
        if (success) {
          const { id } = this.category
          const formData = this.createFormData()
          if (formData) {
            this.edit({ id, category: formData })
          }
        }
      })
    },
    createFormData() {
      const data = new FormData()

      data.append('name', this.category.name)
      data.append('description', this.category.description)
      data.append('active', this.category.active)

      return data
    },
  },
  async created() {
    await this.getCategory(this.$route.params.id)
  },
}
</script>
